// src/pages/admin/AdminVocabularyManagement.tsx
import React, { useState } from "react";
import {
  FaBook,
  FaUsers,
  FaChartBar,
} from "react-icons/fa";
import PageHeader from "../../../core/common/header/PageHeader";
import WordManagement from "./WordManagement";
import BatchManagement from "./Batchmanagement";
import ProgressOverview from "./ProgressOverview";

type Tab = "words" | "batches" | "progress";

const AdminVocabularyManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>("words");

  const tabs = [
    { id: "words" as Tab, label: "Word Management", icon: FaBook },
    { id: "batches" as Tab, label: "Batch Management", icon: FaUsers },
    { id: "progress" as Tab, label: "Progress Overview", icon: FaChartBar },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <PageHeader
        icon={<FaBook />}
        title="Vocabulary Management"
        breadcrumb={[
          { label: "Home", to: "/" },
          { label: "Admin Dashboard", to: "/admin/dashboard" },
          { label: "Vocabulary Management" },
        ]}
      />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-md border border-gray-200 mb-6">
          <div className="flex border-b border-gray-200">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex-1 flex items-center justify-center gap-2 px-6 py-4 font-semibold transition-all ${
                    activeTab === tab.id
                      ? "bg-[#009fe3] text-white border-b-4 border-[#0088cc]"
                      : "text-gray-600 hover:bg-gray-50"
                  }`}
                >
                  <Icon size={20} />
                  <span className="hidden sm:inline">{tab.label}</span>
                  <span className="sm:hidden">{tab.label.split(" ")[0]}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
          {activeTab === "words" && <WordManagement />}
          {activeTab === "batches" && <BatchManagement />}
          {activeTab === "progress" && <ProgressOverview />}
        </div>
      </main>
    </div>
  );
};

export default AdminVocabularyManagement;
